import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { InputBoxModule } from 'app/shared/components/input-box/input-box.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { ScrollViewModule } from 'app/shared/components/scroll-view/scroll-view.module';
import { SelectBoxModule } from 'app/shared/components/select-box/select-box.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { InputColorBoxModule } from '../../../input-color-box/input-color-box.module';
import { RangeSliderModule } from '../../../range-slider/range-slider.module';
import { TypeUtilizationBoxModule } from '../type-utilization-box/type-utilization-box.module';
import { BufferFormComponent } from './buffer-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ScrollViewModule,
    SelectBoxModule,
    InputBoxModule,
    ButtonModule,
    ModalModule,
    TypeUtilizationBoxModule,
    PipesModule,
    InputColorBoxModule,
    RangeSliderModule
  ],
  declarations: [BufferFormComponent],
  exports: [BufferFormComponent],
})
export class BufferFormModule { }
